import { render, staticRenderFns } from "./invoice-activation.vue?vue&type=template&id=67cb6e48"
import script from "./invoice-activation.vue?vue&type=script&lang=js"
export * from "./invoice-activation.vue?vue&type=script&lang=js"
import style0 from "./invoice-activation.vue?vue&type=style&index=0&id=67cb6e48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports